<template>
  <div id="swiper">
    <div class="swiper">
      <swiper :options="swiperOption" v-if="list.length > 0">
        <swiper-slide v-for="(item, index) in list" :key="index">
          <img class="swiper_img" :src="item.imgUrl ? (url + item.imgUrl) : defaultimg">
        </swiper-slide>
        <!-- 分页器 -->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="search">
      <router-link class="search-box border" tag="div" to="/search">
        <i class="iconfont">&#xe706;</i>
        <input type="text" placeholder="输入您想查询的商品" name="search">
      </router-link>
    </div>
  </div>
</template>

<script>
import url from '@/common/common.js'
let vm
export default {
  name: 'HomeSwiper',
  props: {
    list: Array
  },
  data () {
    return {
      url,
      swiperOption: {
        pagination: {
          el: '.swiper-pagination'
        }, // pagination: '.swiper-pagination'分页器不显示
        loop: true,
        autoplay: true,
        speed: 400,
        on: {
          click () {
            vm.$router.push({
              path: '/detail/' + vm.list[this.realIndex].url
            })
          }
        }
      },
      defaultimg: '/static/img/defaultimg.jpg' // 默认图片
    }
  },
  mounted () {
    vm = this
  }
}
</script>

<style scoped>
.swiper-pagination >>> .swiper-pagination-bullet-active{ background: #ff6700;}
.swiper-container >>> .swiper-pagination-bullets{ top: 0;}
body,#swiper{ height: 100%; background: #fff;}
#swiper{ position: relative; height: 195px; min-height: 100%;}
.swiper{ z-index: 1;}
.swiper_img{ width: 100%; height: 175px;}
.search{ padding: 10px 8px;}
.search-box{ display: flex; justify-content: space-around; background-color: #fff; position: absolute; top: 158px; left: 2%; right: 2%; border-radius: 3px; z-index: 2; box-shadow: 0px 2px 5px #eee;}
.search input{ border: 0; padding-left: 5px; line-height: 33px; width: 66%;}
input::-webkit-input-placeholder{ color:#7f7f7f; font-size: 14px; font-weight: normal; font-family: Arial,"Microsoft YaHei";}
.search .iconfont{ line-height: 32px; margin-left: auto; font-size: 14px;}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/Swiper.vue